export const initialState = {
    mirchiMurgaList: [],
  };